"use strict";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var platform = require('platform');

var Api = require('./Api');

var Storage = require('./Storage');

var ApiUrls = require('./modules/ApiUrls');

var Registration = require('./modules/Registration');

var Auth = require('./modules/Auth');

var Me = require('./modules/Me');

var Incognito = require('./modules/Incognito');

var Purchases = require('./modules/Purchases');

var Media = require('./modules/Media');

var System = require('./modules/System');

var Users = require('./modules/Users');

var Chats = require('./modules/chats/Chats');

var Events = require('./modules/Events');

var Koth = require('./modules/Koth');

var Centrifugo = require('./modules/Centrifugo');

var RandomChats = require('./modules/RandomChats');

var Turnons = require('./modules/Turnons');

var config = require('./config');

var EventEmitter = require('eventemitter3');

var packageData = require('../package');

var Banners = require('./modules/Banners');

var WaitingList = require('./modules/WaitingList');

var SmartLikes = require('./modules/SmartLikes');

var BlockList = require('./modules/BlockList');

var Goddess = require('./modules/Goddess');

var formUserAgent = function formUserAgent(name, version, deviceInfo) {
  return "".concat(name, "/").concat(version, " (").concat(deviceInfo, ") SoulSDK/").concat(packageData.version, " (JS)");
};

var getDeviceInfo = function getDeviceInfo(lang) {
  var UNDETECTED = 'undetected';
  var os = platform.os.toString() || '';
  var device = platform.product || window.navigator.platform || UNDETECTED;
  var language = lang || window.navigator.language || 'en-US';
  var browser = "".concat(platform.name, " ").concat(platform.version) || UNDETECTED;
  return "JS 1.0; ".concat(os, " ").concat(device, " ").concat(browser, "; ").concat(language);
};
/**
* SoulSDK
*/


var SoulSDK =
/*#__PURE__*/
function () {
  /**
  * SoulSDK constructor
  * @param {Object} params
  * @param {Object} params.app
  * @param {String} params.app.name - Application name
  * @param {String} params.app.version - Application version
  * @param {String} params.app.language - Application language
  * @param {String} params.apiKey - SOUL API key
  * @param {String} params.apiHost - Root SOUL API endpoint
  * @default https://testing-api.soulplatform.com/
  * @param {String} params.chats - SOUL chats parameters
  * @param {String} params.chats.chatWsHost - WS url for soul chats
  * @param {Boolean} params.sessionRecovery - Set true if you neeed session recovery after 401 erorr
  * @param {Boolean} params.requestMetadata - Set false if you want to receive only body of response
  * @return {Object} Soul Api instance
  */
  function SoulSDK(_ref) {
    var _ref$app = _ref.app,
        name = _ref$app.name,
        version = _ref$app.version,
        language = _ref$app.language,
        apiKey = _ref.apiKey,
        _ref$apiHost = _ref.apiHost,
        apiHost = _ref$apiHost === void 0 ? config.defaultApiEndpoint : _ref$apiHost,
        apiDiscoveryHost = _ref.apiDiscoveryHost,
        centrifugoWsHost = _ref.centrifugoWsHost,
        goddessApiHost = _ref.goddessApiHost,
        chatWsHost = _ref.chats.chatWsHost,
        _ref$sessionRecovery = _ref.sessionRecovery,
        sessionRecovery = _ref$sessionRecovery === void 0 ? true : _ref$sessionRecovery,
        _ref$requestMetadata = _ref.requestMetadata,
        requestMetadata = _ref$requestMetadata === void 0 ? true : _ref$requestMetadata,
        _ref$testing = _ref.testing,
        testing = _ref$testing === void 0 ? false : _ref$testing,
        anonymousUserServiceKey = _ref.anonymousUserServiceKey,
        sendAmplitudeEvent = _ref.sendAmplitudeEvent;

    _classCallCheck(this, SoulSDK);

    this.VERSION = packageData.version;
    this.apiKey = apiKey;
    var eventEmitter = new EventEmitter({
      maxListeners: 0 // unlimited

    });
    var storage = new Storage();
    var apiUrls = new ApiUrls({
      testing: testing,
      apiDiscoveryHost: apiDiscoveryHost,
      dnsProvidersUrls: config.dnsProvidersUrls,
      apiKey: apiKey,
      apiHost: apiHost,
      chatWsHost: chatWsHost,
      centrifugoWsHost: centrifugoWsHost,
      goddessApiHost: goddessApiHost,
      sendAmplitudeEvent: sendAmplitudeEvent
    });
    this.api = new Api({
      requestMetadata: requestMetadata,
      apiUrls: apiUrls,
      storage: storage,
      eventEmitter: eventEmitter,
      apiKey: apiKey,
      sessionRecovery: sessionRecovery
    });
    this.storage = storage;
    this.storage.set('apiKey', apiKey);
    var userAgent = formUserAgent(name, version, getDeviceInfo(language));
    this.parameters = {
      name: name,
      version: version,
      language: language
    };
    this.storage.set('userAgent', userAgent);
    var moduleParams = {
      api: this.api,
      eventEmitter: eventEmitter,
      apiKey: apiKey,
      storage: storage,
      apiUrls: apiUrls
    };
    var usersParams = Object.assign({}, moduleParams, {
      anonymousUserServiceKey: anonymousUserServiceKey
    });
    this.registration = new Registration(moduleParams);
    this.me = new Me(moduleParams);
    this.incognito = new Incognito(moduleParams);
    this.auth = new Auth(moduleParams, this.me);
    this.purchases = new Purchases(moduleParams);
    this.system = new System(moduleParams);
    this.media = new Media(moduleParams);
    this.users = new Users(usersParams);
    this.chats = new Chats(moduleParams);
    this.events = new Events(moduleParams);
    this.koth = new Koth(moduleParams);
    this.centrifugo = new Centrifugo(moduleParams);
    this.randomChats = new RandomChats(moduleParams);
    this.turnons = new Turnons(moduleParams);
    this.banners = new Banners(moduleParams);
    this.waitingList = new WaitingList(moduleParams);
    this.smartLikes = new SmartLikes(moduleParams);
    this.blockList = new BlockList(moduleParams);
    this.goddess = new Goddess(moduleParams);
    this.auth.phone = this.registration.phone; // alias

    this.on = eventEmitter.on.bind(eventEmitter);
    this.off = eventEmitter.off.bind(eventEmitter);
  }

  _createClass(SoulSDK, [{
    key: "setLanguage",
    value: function setLanguage(language) {
      if (language !== this.parameters.language) {
        var userAgent = formUserAgent(this.parameters.name, this.parameters.version, getDeviceInfo(language));
        this.parameters = _objectSpread({}, this.parameters, {
          language: language
        });
        this.storage.set('userAgent', userAgent);
      }
    }
  }]);

  return SoulSDK;
}();

module.exports = SoulSDK;